<template>
    <component
        :is="products"
        :brand="brand"
        :request-for-categories="requestForCategories"
        :is-category-page="isCategoryPage"
        :filter2subcategories="filter2subcategories"
        @resetFilters="resetFilters"
    />
</template>

<script>
import { mapGetters } from 'vuex'

import ProductsPublic from '@/components/Public/Brand/Products/ProductsPublic'
import ProductsPublicRetailer from '@/components/Public/Brand/Products/ProductsPublicRetailer'

export default {
    name: 'PublicBrandProducts',

    components: {
        ProductsPublic,
        ProductsPublicRetailer
    },

    props: {
        brand: {
            type: Object,
            required: true
        },
        requestForCategories: {
            type: Boolean,
            required: false,
            default: false
        },
        isCategoryPage: {
            type: Boolean,
            required: false,
            default: false
        },
        filter2subcategories: {
            type: [Object, String],
            required: false
        }
    },

    computed: {
        ...mapGetters('user', ['isRetailer']),
        products() {
            return this.isRetailer ? ProductsPublicRetailer : ProductsPublic
        }
    },

    methods: {
        resetFilters() {
            this.$emit('resetFilters')
        }
    }
}
</script>
